import { render, staticRenderFns } from "./button-list.vue?vue&type=template&id=5c84d4d6&scoped=true"
import script from "./button-list.vue?vue&type=script&lang=js"
export * from "./button-list.vue?vue&type=script&lang=js"
import style0 from "./button-list.vue?vue&type=style&index=0&id=5c84d4d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84d4d6",
  null
  
)

export default component.exports